/**
 * Состав пака «cinematic-photo» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 59 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 26 из 59 воронок: palette → ближайшая тема по цветам
    { themeId: 'bento-brutalist', weight: 0.44 },
    // 11 из 59 воронок: palette → ближайшая тема по цветам
    { themeId: 'midnight-emerald', weight: 0.19 },
    // 7 из 59 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.12 },
  ],
  fonts: [
    // 52 из 59 воронок: fontId
    { fontId: 'inter', weight: 0.88 },
    // 3 из 59 воронок: fontId
    { fontId: 'poppins', weight: 0.05 },
    // 2 из 59 воронок: fontId
    { fontId: 'roboto', weight: 0.03 },
  ],
  screenKinds: [
    // средняя доля экранов по 59 воронкам (признаки.json kinds) 0.325
    { kind: 'N4', share: 0.46 },
    // средняя доля экранов по 59 воронкам (признаки.json kinds) 0.157; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.22 },
    // средняя доля экранов по 59 воронкам (признаки.json kinds) 0.127
    { kind: 'N10', share: 0.18 },
    // средняя доля экранов по 59 воронкам (признаки.json kinds) 0.060; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.08 },
    // средняя доля экранов по 59 воронкам (признаки.json kinds) 0.034
    { kind: 'N1', share: 0.05 },
  ],
  blocks: [
    // в 22 из 59 воронок (признаки.json blocks), подъём 0.54; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 158 из 182, optionIndicator 172 из 182
    {
      type: 'single_choice',
      weight: 0.37,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 11 из 59 воронок (признаки.json blocks), подъём 0.41; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 47 из 63
    {
      type: 'multiple_choice',
      weight: 0.19,
      settings: { optionIndicator: 'none' },
    },
    // в 36 из 59 воронок (признаки.json blocks), подъём 1.27
    { type: 'loader_processing', weight: 0.61, settings: {} },
  ],
  niches: [
    // 9 из 59 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.15 },
    // 7 из 59 воронок (признаки.json theme)
    { niche: 'health', weight: 0.12 },
    // 6 из 59 воронок (признаки.json theme)
    { niche: 'mental_health', weight: 0.1 },
    // 5 из 59 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.08 },
  ],
};
